import { useEffect, useState } from "react";
import PublicLayout from "@/components/layout/PublicLayout";
import SectionEyebrow from "@/components/common/SectionEyebrow";
import StatusBadge from "@/components/common/StatusBadge";
import { publicApi } from "@/lib/api";
import { Mic, BookOpen, Newspaper, Trophy, Image as ImageIcon, ArrowUpRight } from "lucide-react";

const ICONS = { talk: Mic, book_launch: BookOpen, press: Newspaper, podcast: Mic, interview: Mic, article: Newspaper, award: Trophy, gallery: ImageIcon };

export default function Media() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(null);
  useEffect(() => {
    publicApi.media().then(setItems).catch(() => {});
    publicApi.page("media").then(setPage).catch(() => {});
  }, []);
  return (
    <PublicLayout title="Media & Insights">
      <section className="relative bsca-dark bsca-cosmic bsca-grain -mt-16 md:-mt-20 lg:-mt-[88px] pt-36 md:pt-44 pb-24 overflow-hidden">
        <div className="bsca-field-lines" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14 bsca-fade-up">
          <SectionEyebrow dark>{page?.hero?.eyebrow || "Media & Insights"}</SectionEyebrow>
          <h1 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">{page?.hero?.headline}</h1>
          <p className="mt-6 text-white/75 text-lg max-w-2xl">{page?.hero?.subheadline}</p>
        </div>
      </section>
      <section className="bg-[#F8F6F1] py-24">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-px bg-black/10 border border-black/10 bsca-stagger">
          {items.map((m, i) => {
            const Icon = ICONS[m.type] || Newspaper;
            return (
              <div key={`${m.title}-${m.type || ""}-${m.date || ""}`} data-testid={`media-card-${m.title}`} className="bg-white p-8">
                <div className="flex items-start justify-between">
                  <Icon className="h-5 w-5 text-[#D4AF37]" />
                  <StatusBadge status={m.status} />
                </div>
                <h3 className="mt-5 font-serif text-2xl tracking-tight">{m.title}</h3>
                <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">{m.description}</p>
                {m.link ? (
                  <a href={m.link} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex items-center bsca-link text-sm">Open <ArrowUpRight className="h-3 w-3 ml-1" /></a>
                ) : (
                  <div className="mt-5 text-xs text-[#9CA3AF] italic">Media link pending</div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </PublicLayout>
  );
}
